import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import Button from "../../../ui/molecules/button"
import Input from "../../../ui/molecules/input"
import { resetSotValidationStatus, setOnEdit, setSotUpdateAddress, setSotUpdateCity, setSotUpdateCode, setSotUpdateEmail, setSotUpdateFax, setSotUpdateManager, setSotUpdateName, setSotUpdatePec, setSotUpdatePhone, setSotUpdateProvince, setSotUpdateRegion, setSotUpdateZipcode, SOTUpdate, SotValidation } from "../slice"
import { OptionType, regioniProvinceMap, regions, Region, Province } from "../../../utils"
import { provinceComuniMap } from "../../../utils/listaComuni"
import { SelectCustom } from "../../../ui/molecules/select"

interface Props {
    close: () => void
}

export function SOTPopupEdit(props: Props) {
    const dispatch = useAppDispatch()
    const sotState = useAppSelector(state => state.headQuarter)
    const [provinceOptions, setProvinceOptions] = useState<OptionType[]>([]);
    const [selectedRegion, setSelectedRegion] = useState<OptionType | null>(null);
    const [comuneOptions, setComuneOptions] = useState<OptionType[]>([]);
    const [selectedComune, setSelectedComune] = useState<OptionType | null>(null);
    const [selectedProvince, setSelectedProvince] = useState<OptionType | null>(null);

    const regionOptions: OptionType[] = Array.from(regioniProvinceMap.keys()).map(region => ({
        value: region,
        label: region
    }));

    useEffect(() => {
        if (selectedRegion) {
            const foundRegion = regions.find((region: Region) => region.name === selectedRegion.toString());
            if (foundRegion) {
                const newProvinceOptions = foundRegion.provinces.map((province: Province) => ({
                    value: province.code,
                    label: province.name
                }));
                setProvinceOptions(newProvinceOptions);
            } else {
                setProvinceOptions([]);
            }
        } else {
            setProvinceOptions([]);
        }
    }, [selectedRegion]);

    useEffect(() => {
        if (selectedProvince) {
            const comuni = provinceComuniMap.get(selectedProvince.toString()) || [];
            const newComuneOptions = comuni.map((comune: string) => ({
                value: comune,
                label: comune
            }));
            setComuneOptions(newComuneOptions);
        } else {
            setComuneOptions([]);
        }
    }, [selectedProvince]);

    const handleRegionChange = (selectedOption: OptionType | null) => {
        setSelectedRegion(selectedOption);
        setSelectedProvince(null); // Reset province when region changes
        setSelectedComune(null);
    };

    const handleProvinceChange = (selectedOption: OptionType | null) => {
        setSelectedProvince(selectedOption);
        setSelectedComune(null);
    };

    useEffect(() => {
        if (sotState.sotUpdateRequest.region) {
            const foundRegion = regions.find((region: Region) => region.name === sotState.sotUpdateRequest.region!.toString());
            if (foundRegion) {

                const newProvinceOptions = foundRegion.provinces.map((province: Province) => ({
                    value: province.code,
                    label: province.name
                }));

                setProvinceOptions(newProvinceOptions);
            } else {
                setProvinceOptions([]);
            }
        } else {
            setProvinceOptions([]);
        }

        if (sotState.sotUpdateRequest.province) {
            const comuni = provinceComuniMap.get(sotState.sotUpdateRequest.province.toString()) || [];
            const newComuneOptions = comuni.map((comune: string) => ({
                value: comune,
                label: comune
            }));
            setComuneOptions(newComuneOptions);
        } else {
            setComuneOptions([]);
        }
    }, [])

    useEffect(() => {
        if (sotState.sotValidationStatus === 'successfully') {
            dispatch(resetSotValidationStatus())
            dispatch(SOTUpdate({ body: sotState.sotUpdateRequest, id: sotState.sotIdToUpdate }))
        }
    }, [sotState.sotValidationStatus])

    useEffect(() => {
        if (sotState.sotUpdateStatus === 'successfully' && sotState.onEdit) {
            dispatch(setOnEdit(false))
            props.close()
        }
    }, [sotState.sotUpdateStatus])

    return (
        <div>
            <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-5" style={{ borderTopWidth: 1 }}>
                <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Codice'}
                            placeholder="Specifica codice..."
                            error={sotState.sotErrors.code}
                            supportingText={sotState.sotErrors.code ? 'Codice mancante' : undefined}
                            value={sotState.sotUpdateRequest.code}
                            onChangeText={(text) => dispatch(setSotUpdateCode(text))}
                        />
                    </div>

                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Nome'}
                            placeholder="Specifica nome..."
                            value={sotState.sotUpdateRequest.name}
                            onChangeText={(text) => dispatch(setSotUpdateName(text))}
                        />
                    </div>

                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Email'}
                            placeholder="Specifica email..."
                            error={sotState.sotErrors.email}
                            supportingText={sotState.sotErrors.email ? 'Email mancante' : undefined}
                            value={sotState.sotUpdateRequest.email}
                            onChangeText={(text) => dispatch(setSotUpdateEmail(text))}
                        />
                    </div>
                </div>

                <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'PEC'}
                            placeholder="Specifica PEC..."
                            value={sotState.sotUpdateRequest.pec}
                            onChangeText={(text) => dispatch(setSotUpdatePec(text))}
                        />
                    </div>

                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Telefono'}
                            placeholder="Specifica telefono..."
                            value={sotState.sotUpdateRequest.phone}
                            onChangeText={(text) => dispatch(setSotUpdatePhone(text))}
                        />
                    </div>

                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Fax'}
                            placeholder="Specifica fax..."
                            value={sotState.sotUpdateRequest.fax}
                            onChangeText={(text) => dispatch(setSotUpdateFax(text))}
                        />
                    </div>
                </div>

                <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.33' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '6px' }}>
                            <span className="input-label">Regione</span>
                        </div>
                        <SelectCustom
                            error={sotState.sotErrors.region}
                            errorLabel={'Regione mancante'}
                            value={sotState.sotUpdateRequest.region}
                            placeholder={'Regione'}
                            options={regionOptions}
                            onChange={(value) => { handleRegionChange(value as unknown as OptionType | null); dispatch(setSotUpdateRegion(value)) }}
                        />
                    </div>

                    <div style={{ flex: '0.33' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '6px' }}>
                            <span className="input-label">Provincia</span>
                        </div>
                        <SelectCustom
                            error={sotState.sotErrors.province}
                            errorLabel={'Provincia mancante'}
                            placeholder={'Provincia'}
                            options={provinceOptions}
                            value={sotState.sotUpdateRequest.province}
                            onChange={(value) => { handleProvinceChange(value as unknown as OptionType | null); dispatch(setSotUpdateProvince(value)) }}
                        />
                    </div>

                    <div style={{ flex: '0.33' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '6px' }}>
                            <span className="input-label">Comune</span>
                        </div>
                        <SelectCustom
                            error={sotState.sotErrors.city}
                            errorLabel={'Città mancante'}
                            value={sotState.sotUpdateRequest.city}
                            placeholder={'Comune'}
                            options={comuneOptions}
                            onChange={(text) => { dispatch(setSotUpdateCity(text)) }}
                        />
                    </div>
                </div>

                <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Indirizzo'}
                            placeholder="Specifica indirizzo..."
                            error={sotState.sotErrors.address}
                            supportingText={sotState.sotErrors.address ? 'Indirizzo mancante' : undefined}
                            value={sotState.sotUpdateRequest.address}
                            onChangeText={(text) => dispatch(setSotUpdateAddress(text))}
                        />
                    </div>

                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'CAP'}
                            placeholder="Specifica CAP..."
                            value={sotState.sotUpdateRequest.zipCode}
                            onChangeText={(text) => dispatch(setSotUpdateZipcode(text))}
                        />
                    </div>

                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Manager'}
                            placeholder="Specifica manager..."
                            value={sotState.sotUpdateRequest.manager}
                            onChangeText={(text) => dispatch(setSotUpdateManager(text))}
                        />
                    </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: 10, paddingRight: 15 }}>
                    <Button
                        size="md"
                        variant="outline"
                        iconPosition="off"
                        label="Annulla"
                        color="dimgrey"
                        onClick={() => {
                            dispatch(setOnEdit(false))
                            props.close();
                        }}
                    />
                    <div className="pl-2">
                        <Button
                            size="md"
                            variant="solid"
                            iconPosition="off"
                            label="Salva"
                            color="orange"
                            onClick={() => dispatch(SotValidation(sotState.sotUpdateRequest))}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}